import { TeceoApiResponse, default as createRepository } from '../../lib/basicRepository';
import { restApi } from '../../services/api';
import { GetCnpjIntegrationDTO } from '../../types/cnpjIntegration.types';

export const storeRepository = () => {
  const validateCnpjForSignUp = (cnpj: string): Promise<TeceoApiResponse<GetCnpjIntegrationDTO>> =>
    restApi.get(`/stores/validate-cnpj?cnpj=${cnpj}`);

  const basicRepository = createRepository({
    path: `stores`,
    restApi,
  });

  return {
    validateCnpjForSignUp,
    ...basicRepository,
  };
};

export const storeAddressRepository = (id: string) =>
  createRepository({
    path: `stores/address`,
    id,
    restApi,
  });
